export default __webpack_public_path__ + "static/favicon-71872a84e857e4d9d98b73dff31cc46e.ico";